export default __webpack_public_path__ + "static/media/VEB_limitedIndemnity.6206b76b.png";